import {
  femaleIndicatorIcon,
  maleIndicatorIcon,
  openEyeBlackIcon,
  playBlackIcon,
  profileBlackIcon,
} from 'resources/images';

const Constants = () => {
  // ENUMS
  const enums = {
    CAMPAIGN_NAME: 'campaignName',
    CAMPAIGN_OBJECTIVE: 'campaignObjective',
    BRIEF: 'brief',
    TARGET_AUDIENCE: 'targetAudience',
    BUDGET: 'budget',
    MAX_VIDEOS_PER_CREATOR: 'maxVideosPerCreator',
  };

  // ROUTE NAMES
  const routeNames = {
    createCampaign: '/',
    login: '/login',
    signUp: '/signup',
    overView: '/overview',
    eventCampaign: '/eventcampaign',
    viewCampaign: '/viewcampaign',
    extendCampaign: '/extendcampaign',
    privacyPolicy: '/privacypolicy',
    termsAndConditions: '/terms&conditions',
    breifGenerator: '/briefgenerator',
    tools: '/tools',
  };

  // HEADER MENU DATA
  const menuData = [
    {
      name: 'Create Campaign',
      route: routeNames.createCampaign,
    },
    {
      name: 'Tools ',
      route: routeNames.tools,
    },
    {
      name: 'Overview',
      route: routeNames.overView,
    },

    // TODO: LATER ADD THIS ROUTE
    // {
    //   name: 'Event Campaign',
    //   route: routeNames.eventCampaign,
    // },
  ];

  // GENDER STATISTICS DATA

  const genderStatisticsData = [
    {
      icon: maleIndicatorIcon,
      percentage: '60%',
      gender: 'Male',
    },
    {
      icon: femaleIndicatorIcon,
      percentage: '40%',
      gender: 'Female',
    },
  ];

  // CAMPAIGN PREVIEW STATISTICS DATA
  const campaignPreviewStatisticsData = [
    {
      icon: playBlackIcon,
      label: 'Total Videos',
      count: ' 100',
    },
    {
      icon: profileBlackIcon,
      label: 'Estimate Unique Creators',
      count: '50',
    },
    {
      icon: openEyeBlackIcon,
      label: 'Estimate Total Views',
      count: '2 000 000',
    },
  ];

  // EXTEND CAMPAIGN PREVIEW STATISTIC DATA
  const extendCampaignPreviewStatisticsData = [
    {
      icon: playBlackIcon,
      label: 'Additional Videos',
      count: '+100',
    },
    {
      icon: profileBlackIcon,
      label: 'Estimate Additional Creators',
      count: '+50',
    },
    {
      icon: openEyeBlackIcon,
      label: 'Estimate Additional Views',
      count: '+2 000 000',
    },
  ];

  // CAMPAIGN OPTIONS DATA
  const campaignDaysOptionsData = [
    {
      label: '1 day',
      value: 1,
    },
    {
      label: '7 days',
      value: 7,
    },
    {
      label: '90 days',
      value: 90,
    },
    {
      label: '1 year',
      value: 365,
    },
    {
      label: 'all time',
      value: null,
    },
  ];

  const fixedBudgetAndViews = [
    {
      budget: 1500,
      no_of_videos: { low: 21, heigh: 33 },
      views: { low: 165000, high: 210000 },
    },
    {
      budget: 2000,
      no_of_videos: { low: 28, heigh: 44 },
      views: { low: 220000, high: 280000 },
    },
    {
      budget: 3000,
      no_of_videos: { low: 42, heigh: 66 },
      views: { low: 330000, high: 420000 },
    },
    {
      budget: 4000,
      no_of_videos: { low: 57, heigh: 88 },
      views: { low: 440000, high: 570000 },
    },
    {
      budget: 5000,
      no_of_videos: { low: 71, heigh: 111 },
      views: { low: 555000, high: 710000 },
    },
    {
      budget: 7500,
      no_of_videos: { low: 107, heigh: 166 },
      views: { low: 775000, high: 1100000 },
    },
    {
      budget: 10000,
      no_of_videos: { low: 142, heigh: 222 },
      views: { low: 950000, high: 1420000 },
    },
    {
      budget: 15000,
      no_of_videos: { low: 214, heigh: 333 },
      views: { low: 1275000, high: 2120000 },
    },
  ];

  return {
    enums,
    routeNames,
    menuData,
    genderStatisticsData,
    campaignPreviewStatisticsData,
    extendCampaignPreviewStatisticsData,
    campaignDaysOptionsData,
    fixedBudgetAndViews,
  };
};

export { Constants };
